module.exports = __webpack_public_path__ + "assets/vehicle-dark.6e6e1f55.svg";